import { render, staticRenderFns } from "./AlertEliminazioneRilevamento.vue?vue&type=template&id=0aa0797c&scoped=true&lang=pug&"
import script from "./AlertEliminazioneRilevamento.vue?vue&type=script&lang=ts&"
export * from "./AlertEliminazioneRilevamento.vue?vue&type=script&lang=ts&"
import style0 from "./AlertEliminazioneRilevamento.vue?vue&type=style&index=0&id=0aa0797c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa0797c",
  null
  
)

export default component.exports